import  {__extends} from './eXcell';
import eXcell_edn from './eXcell_edn';

var eXcell_switch_ed = (function (_super) {
    __extends(eXcell_switch_ed, _super);
    function eXcell_switch_ed(cell) {
        _super.call(this);

        this.base = eXcell_edn;
        this.base(cell);
    }
    eXcell_switch_ed.prototype.getValue = function () {
        return $(this.cell).find("input").val();
    };
    eXcell_switch_ed.prototype.isDisabled = function () {
        return true;
    };
    eXcell_switch_ed.prototype.edit = function () {
        return false;
    };
    return eXcell_switch_ed;
})(eXcell_edn);
eXcell_switch_ed.prototype.setValue = function (val,initEventAgain) {
    if(val===true||val==="true"||val==="1"||val===1){
        val=true;
    }else{
        val=false;
    }
    let cellInedx=this.cell._cellIndex;
    let ctlId=`cell_switch_${this.cell.parentNode.idd}_${cellInedx}`;
    let html=val ? `<span tabindex="0" id="${ctlId}"  class="ivu-switch ivu-switch-checked ivu-switch-default"><input type="hidden" value="true"> <span class="ivu-switch-inner"></span></span>`:
        `<span id="${ctlId}" tabindex="0" class="ivu-switch ivu-switch-default"><input type="hidden" value="false"> <span class="ivu-switch-inner"><!----> </span></span>`;
    this.cell.innerHTML = this.grid._aplNF(html, this.cell._cellIndex);
    if(initEventAgain){
        this.grid.initSwitchEventAgain([this.cell.parentNode.idd],cellInedx);
    }

};
window.eXcell_switch_ed = eXcell_switch_ed;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_switch_ed.js